export default {
  successfulClientUpdate: "Client updated successfully",
  deleteSuccess: "Client deleted successfully",
  confirmDeleteTitle: "Delete Client",
  confirmDeleteTitle_plural: "Delete Clients",
  confirmDeleteMessage: "Are you sure you want to delete this client?",
  confirmDeleteMessage_plural:
    "Are you sure you want to delete these {{count}} clients?",
  deleteError:
    "Sorry, this client could not be deleted due to an error on our end. Please try again later.",
  name: "Name",
  email: "Email",
  contacts: "Contacts",
  addContact: "Add Contact",
  editContact: "Edit Contact",
  deleteContact: "Delete Contact",
  firstName: "First Name",
  lastName: "Last Name",
  contactEmail: "Email",
  contactPhone: "Phone",
  createNewContact: "Create Contact",
  successfulContactCreate: "Contact created successfully",
  successfulContactUpdate: "Contact updated successfully",
  confirmDeleteContactTitle: "Delete Contact",
  confirmDeleteContactMessage: "Are you sure you want to delete this contact?",
  deleteContactSuccess: "Contact deleted successfully",
  deleteContactError:
    "Sorry, this contact could not be deleted due to an error on our end. Please try again later.",
  noContacts: "No contacts",
  noContactsMessage:
    "This client doesn't have any contacts yet. Add one to get started.",
};
